import { addObjectToScene } from "../scripts/addObjectToScene";
import { resetShelfBlocks } from "../scripts/addShelfBlock";
import { openCorrectSideMenu } from "../scripts/dynamicLoader";
import { cardItems } from "../scripts/vars/cardItems";
import { getTableName } from "./getTableName";

export const loadPage = async () => {
    const params = new URLSearchParams(window.location.search);
    const category_param = params.get("category");
    const type_param = params.get("type");
    const name_params = params.get("name");

    if (type_param && name_params) {
        const target_table = cardItems[category_param][type_param]?.find((item) => item.pageName === name_params);
        if (!target_table) {
            console.warn(`Table with pageName "${name_params}" not found in type "${type_param}"`);
            return;
        }
        const {
            name,
            tempName,
            glbName,
            glbPath,
            nextMenu,
            menuTitle,
            allArrTable,
            folderName,
            typeName,
            pageName,
            defaultWidth,
            defaultDepth,
        } = target_table;

        servObj.tempName = tempName;

        const calcTableName = getTableName(target_table);

        await addObjectToScene(
            {
                objectName: name,
                glbName,
                allArrTable,
                glbPath,
                folderName,
                typeName,
                pageName,
                defaultWidth,
                defaultDepth,
                tempName,
            },
            calcTableName,
        );
        await openCorrectSideMenu(nextMenu, menuTitle);
        resetShelfBlocks();

        servObj.targetPageKey = folderName;
    }
    return;
};
